import { render, staticRenderFns } from "./ResourcesTable.vue?vue&type=template&id=6e71980c&scoped=true&"
import script from "./ResourcesTable.vue?vue&type=script&lang=js&"
export * from "./ResourcesTable.vue?vue&type=script&lang=js&"
import style0 from "./ResourcesTable.vue?vue&type=style&index=0&id=6e71980c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e71980c",
  null
  
)

export default component.exports